﻿export class PageUnloadUtilities {

    registerBeforeUnload(dotNetHelper) {
        window.addEventListener("beforeunload", function () {
            dotNetHelper.invokeMethodAsync("OnPageUnload");
        });
    }

    unregisterBeforeUnload() {
        window.removeEventListener("beforeunload", function () {});
    }
}